import type { AssetTreeNode } from "@/entities/asset-tree";

import { useCallback } from "react";

import { useReferentialConditionRatings } from "@/entities/referential/referential-condition-ratings";
import { useOrganizationContext } from "@/modules/organization/organization-context";

import { getTreeNodeMarker } from "./asset-tree-node-marker.helper";

export const useTreeNodeMarker = () => {
  const { contextSlug } = useOrganizationContext();
  const { conditionRatings } = useReferentialConditionRatings();

  const getMarker = useCallback(
    (node: AssetTreeNode) => {
      const context = contextSlug ?? null;
      return getTreeNodeMarker({ context, node, conditionRatings });
    },
    [contextSlug, conditionRatings]
  );

  return {
    getMarker,
  };
};
